var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "voucher-date-cell" },
    [
      [
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "align-items": "center",
              "justify-content": "center"
            }
          },
          [
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.showDate
                    ? _vm.formatDate(_vm.voucherList[0].voucherDate)
                    : _vm.ColumnUtils.voucherStateLabelFunc(
                        _vm.voucherList[0].voucherStatus
                      )
                )
              )
            ]),
            _c(
              "el-popover",
              { attrs: { placement: "right", width: "400", trigger: "hover" } },
              [
                _c(
                  "el-table",
                  {
                    attrs: { data: _vm.voucherList, size: "mini", border: "" }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "voucherNo",
                        label: _vm.$t("CargoMsg.Cargo_VoucherNo"),
                        width: "120"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "voucherDate",
                        label: _vm.$t("CargoMsg.Cargo_ProofDate"),
                        width: "150",
                        formatter: _vm.formatDateByCell
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "voucherStatus",
                        label: _vm.$t("CargoMsg.Cargo_VoucherStatus"),
                        width: "120",
                        formatter: _vm.voucherStatusFormatter
                      }
                    })
                  ],
                  1
                ),
                _c("i", {
                  staticClass: "el-icon-info",
                  staticStyle: { "font-size": "15px", "margin-left": "10px" },
                  attrs: { slot: "reference" },
                  slot: "reference"
                })
              ],
              1
            )
          ],
          1
        )
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }